export async function sendWifiCredentials(
  server: BluetoothRemoteGATTServer,
  serviceUUID: string,
  ssidCharacteristicUUID: string,
  passwordCharacteristicUUID: string,
  encMethodCharacteristicUUID: string,
  ssid: string,
  password: string,
) {
  try {
    const ssidBytes = new TextEncoder().encode(ssid);
    const passwordBytes = new TextEncoder().encode(password);
    const service = await server.getPrimaryService(serviceUUID);

    const ssidCharacteristic = await service.getCharacteristic(
      ssidCharacteristicUUID,
    );
    const passwordCharacteristic = await service.getCharacteristic(
      passwordCharacteristicUUID,
    );

    await ssidCharacteristic.writeValue(ssidBytes);
    await passwordCharacteristic.writeValue(passwordBytes);
    await resetWifi(server, serviceUUID, encMethodCharacteristicUUID);
  } catch (error) {
    console.error("[WebBLEService] Error sending WiFi credentials:", error);
    throw error;
  }
}

async function resetWifi(
  server: BluetoothRemoteGATTServer,
  serviceUUID: string,
  characteristicUUID: string,
) {
  const service = await server.getPrimaryService(serviceUUID);
  const characteristic = await service.getCharacteristic(characteristicUUID);
  await characteristic.writeValue(new Uint8Array([3]));
}

export async function readWifiSSID(
  server: BluetoothRemoteGATTServer,
  serviceUUID: string,
  ssidCharacteristicUUID: string,
): Promise<string | null> {
  try {
    const service = await server.getPrimaryService(serviceUUID);
    const characteristic = await service.getCharacteristic(
      ssidCharacteristicUUID,
    );
    const value = await characteristic.readValue();
    return new TextDecoder().decode(value);
  } catch (error) {
    console.error("Error reading SSID characteristic:", error);
    return null;
  }
}
